import * as angular from "angular";
import { Campaign } from "../models/campaign.model";
import { Organisation } from "../models/organisation.model";
import { User } from "../models/user.model";
import { OrganisationService } from "../services/organisation.service";

export class OrganisationDataProvider {
    private stats: object = null;
    private limits: object = null;
    private statsPromise: any;
    private limitsPromise: any;

    private $q: any;
    private organisationService: OrganisationService;

    constructor($q, OrganisationService) {
        this.$q = $q;
        this.organisationService = OrganisationService;
    }

    headlineStats(oid: string | number): Promise<any> {
        if (this.stats !== null) {
            return this.$q.resolve(this.stats);
        } else if (this.statsPromise) {
            //Has been called already and has not resolved yet.
            return this.statsPromise;
        } else {
            const deferred = this.$q.defer();

            this.organisationService.headlineStats({ oid: oid }).then(
                (response) => {
                    const json = response["data"];
                    this.stats = json.data;
                    deferred.resolve(this.stats);
                },
                (error) => {
                    this.stats = [];
                    deferred.reject(error);
                }
            );

            this.statsPromise = deferred.promise;
            return this.statsPromise;
        }
    }

    updateCampaignLimits(
        organisation: Organisation,
        campaigns: Campaign[]
    ): Promise<any> {
        const deferred = this.$q.defer();
        this.organisationService
            .updateCampaignLimits({
                oid: organisation.oid,
                campaigns: campaigns,
            })
            .then((response) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                }
                deferred.reject(json);
            });
        return deferred.promise;
    }

    updateUser(user: User): Promise<any> {
        const deferred = this.$q.defer();
        this.organisationService.updateUser(user).then((response) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(json.data);
            }
            deferred.reject(json);
        });
        return deferred.promise;
    }

    updateLeader(organisation): Promise<any> {
        const deferred = this.$q.defer();
        this.organisationService.update(organisation).then((response) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(json);
            }
            deferred.reject(json);
        });
        return deferred.promise;
    }

    getStats(
        organisation: Organisation,
        type,
        startDate: string,
        endDate: string,
        campaignIds: string
    ): Promise<any> {
        const deferred = this.$q.defer();

        this.organisationService
            .stats({
                oid: organisation.oid,
                type: type.id,
                startDate: startDate,
                endDate: endDate,
                campaigns: campaignIds,
            })
            .then((response) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                }
                deferred.reject(json);
            });

        return deferred.promise;
    }

    clearAll() {
        this.stats = null;
        this.limits = null;
    }
}

angular
    .module("vcDataProvider")
    .service("OrganisationDataProvider", OrganisationDataProvider);
